export type BlogCategoryId =
  | 'getting-started'
  | 'instructions'
  | 'release-notes'
  | 'compliance'
  | 'founder-updates';

export const BLOG_CATEGORY_FILTERS: Array<{ id: BlogCategoryId | 'all'; label: string }> = [
  { id: 'all', label: 'All Posts' },
  { id: 'getting-started', label: 'Getting Started' },
  { id: 'instructions', label: 'Instructions' },
  { id: 'release-notes', label: 'Release Notes' },
  { id: 'compliance', label: 'Compliance' },
  { id: 'founder-updates', label: 'Founder Updates' },
];

export interface BlogTagDto {
  label: string;
  tone: string;
}

export interface BlogPostDto {
  id: string;
  slug: string;
  title: string;
  category: string;
  badge: string | null;
  summary: string;
  bodyHtml?: string;
  tags: BlogTagDto[];
  featuredImageUrl: string | null;
  /** Time-limited S3 GET URL when the featured image lives in private `blogs/featured/…` keys. */
  featuredImageDisplayUrl?: string | null;
  thumbIconClass: string | null;
  authorDisplayName: string;
  status: string;
  visibility: string;
  featured: boolean;
  readTimeMinutes: number | null;
  seoTitle: string | null;
  seoDescription: string | null;
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
  createdByUserId: string | null;
}

export interface BlogListPagination {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

/** Server-returned counts for all published public posts (not filtered by current search). */
export type BlogListCategoryCounts = Partial<Record<BlogCategoryId | 'all', number>>;

export interface BlogListResult {
  posts: BlogPostDto[];
  pagination: BlogListPagination;
  categoryCounts: BlogListCategoryCounts & Record<string, number | undefined>;
  featured: BlogPostDto | null;
}

export interface BlogPostPayload {
  title: string;
  category: BlogCategoryId;
  badge?: string | null;
  summary: string;
  bodyHtml: string;
  tags: BlogTagDto[];
  featuredImageUrl?: string | null;
  thumbIconClass?: string | null;
  authorDisplayName: string;
  status: 'DRAFT' | 'READY_FOR_REVIEW' | 'PUBLISHED';
  visibility: 'public' | 'unlisted' | 'internal';
  featured?: boolean;
  seoTitle?: string | null;
  seoDescription?: string | null;
  slug?: string | null;
  publishedAt?: string | null;
}
